/* ==========================================================================
   LILIZOU — script de la marque
   Un seul fichier, sans dépendance. Chaque module se relance quand l'éditeur
   de thème régénère une section (shopify:section:load).
   ========================================================================== */
(function(){
  if(window.__lilizou){return;} window.__lilizou=true;
  var d=document, html=d.documentElement;
  var EDIT=!!(window.Shopify&&window.Shopify.designMode);
  var REDUCE=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(l,f){Array.prototype.forEach.call(l,f);}
  function ready(f){ if(d.readyState!=='loading'){f();} else {d.addEventListener('DOMContentLoaded',f);} }
  function money(cents){
    var fmt=(window.LZ&&window.LZ.money)||'{{amount_with_comma_separator}} €';
    var v=(cents/100).toFixed(2);
    var a=v.replace('.',','), b=v.replace(/\B(?=(\d{3})+(?!\d))/g,' ');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,a).replace(/\{\{\s*amount\s*\}\}/,b);
  }

  /* ------------------------------------------------------------- intro --
     Une fois par session. Un clic la passe. Désactivée dans l'éditeur et
     quand l'utilisateur a demandé moins d'animations. */
  function initIntro(){
    var el=d.querySelector('[data-lz-intro]');
    if(!el||el.__b){return;} el.__b=true;
    var seen=false;
    try{ seen=sessionStorage.getItem('lz-intro')==='1'; }catch(e){}
    if(EDIT||REDUCE||seen){ el.classList.add('gone'); return; }
    html.classList.add('lz-lock');
    var dur=parseInt(el.getAttribute('data-dur')||'2400',10);
    var done=false;
    function close(){
      if(done){return;} done=true;
      try{ sessionStorage.setItem('lz-intro','1'); }catch(e){}
      el.classList.add('out');
      html.classList.remove('lz-lock');
      var hero=d.querySelector('.lz-hero'); if(hero){ hero.classList.add('in'); }
      setTimeout(function(){ el.classList.add('gone'); },1200);
    }
    el.addEventListener('click',close);
    setTimeout(close,dur);
  }

  /* -------------------------------------------------------- apparitions -- */
  var io=null;
  function initReveals(root){
    var els=(root||d).querySelectorAll('[data-lz-rv]:not(.in)');
    if(!els.length){return;}
    if(EDIT||REDUCE||!('IntersectionObserver' in window)){ each(els,function(e){e.classList.add('in');}); return; }
    if(!io){
      io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      },{rootMargin:'0px 0px -8% 0px',threshold:.05});
    }
    each(els,function(e,i){ e.style.transitionDelay=(Math.min(i%6,5)*70)+'ms'; io.observe(e); });
  }
  function initHero(){
    var hero=d.querySelector('.lz-hero');
    if(!hero){return;}
    var intro=d.querySelector('[data-lz-intro]');
    if(!intro||intro.classList.contains('gone')){ requestAnimationFrame(function(){ hero.classList.add('in'); }); }
  }

  /* -------------------------------------------------------------- annonce -- */
  function initAnn(root){
    each((root||d).querySelectorAll('[data-lz-ann]'),function(a){
      if(a.__b){return;} a.__b=true;
      var its=a.querySelectorAll('.lz-ann__i'); if(its.length<2){return;}
      var i=0, t=parseInt(a.getAttribute('data-s')||'4',10)*1000;
      setInterval(function(){ its[i].classList.remove('on'); i=(i+1)%its.length; its[i].classList.add('on'); },t);
    });
  }

  /* --------------------------------------------------------------- header --
     Transparent sur la grande bannière, plein dès qu'on l'a dépassée.
     La bannière est cherchée au scroll : quand ce script tourne, les
     sections suivantes ne sont pas forcément encore dans la page. */
  function initNav(){
    var nav=d.querySelector('[data-lz-nav]');
    if(!nav||nav.__b){return;} nav.__b=true;
    var transp=nav.classList.contains('lz-nav--transp');
    var fixed=nav.classList.contains('lz-nav--fixed');
    // Sur certaines pages, Horizon fait défiler .page-wrapper et non la fenêtre :
    // on se cale sur la position réelle du bandeau, et on écoute le défilement de tout élément.
    function place(){
      if(!fixed){return;}
      var a=d.querySelector('.lz-ann'), top=a?Math.max(0,a.getBoundingClientRect().bottom):0;
      nav.style.top=top+'px';
      if(!transp){return;}
      var hero=d.querySelector('.lz-hero,[data-lz-hero]');
      var solid = hero ? hero.getBoundingClientRect().bottom <= top+nav.offsetHeight+2 : top===0;
      nav.classList.toggle('is-solid',solid);
    }
    d.addEventListener('scroll',place,{passive:true,capture:true});
    window.addEventListener('resize',place);
    window.addEventListener('load',place);
    place();
  }

  /* ---------------------------------------------- tiroirs / modales ------ */
  function openLayer(el){ if(!el){return;} el.classList.add('on'); el.setAttribute('aria-hidden','false'); html.classList.add('lz-lock');
    var f=el.querySelector('button,a,input'); if(f){ setTimeout(function(){ f.focus({preventScroll:true}); },60); } }
  function closeLayers(){ each(d.querySelectorAll('.lz-drawer.on,.lz-qa.on,.lz-modal.on'),function(el){ el.classList.remove('on'); el.setAttribute('aria-hidden','true'); });
    html.classList.remove('lz-lock'); }

  /* ------------------------------------------------------------------ FAQ -- */
  function toggleFaq(q){
    var it=q.closest('[data-lz-faq]'); if(!it){return;}
    var a=it.querySelector('.lz-faq__a'), open=!it.classList.contains('open');
    it.classList.toggle('open',open);
    q.setAttribute('aria-expanded',String(open));
    a.style.maxHeight=open?(a.scrollHeight+'px'):'0px';
  }

  /* ------------------------------------------------------- achat rapide --
     La carte embarque les variantes en JSON. On ouvre un panneau avec les
     pointures : une pointure épuisée reste visible, grisée et barrée. */
  var qaData=null;
  function cartCount(n){ each(d.querySelectorAll('[data-lz-count]'),function(c){ c.textContent=n; }); }
  function addItems(items){
    return fetch((window.LZ&&window.LZ.addUrl)||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items})})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok){ throw j; } return j; }); })
      .then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); })
      .then(function(c){ cartCount(c.item_count); return c; });
  }
  function openQA(card){
    var p=d.querySelector('[data-lz-qa]'); if(!p){ return; }
    var raw=card.querySelector('script[type="application/json"]'); if(!raw){ return; }
    try{ qaData=JSON.parse(raw.textContent); }catch(e){ return; }
    p.querySelector('[data-qa-t]').textContent=qaData.title;
    p.querySelector('[data-qa-p]').textContent=qaData.price;
    var link=p.querySelector('[data-qa-link]'); if(link){ link.href=qaData.url; }
    var box=p.querySelector('[data-qa-sizes]'); box.innerHTML='';
    qaData.variants.forEach(function(v,i){
      var l=d.createElement('label'); l.className='lz-size'+(v.available?'':' off');
      l.innerHTML='<input type="radio" name="lz-qa-v" value="'+v.id+'"'+(v.available?'':' disabled')+'><span>'+v.title+'</span>';
      box.appendChild(l);
    });
    var msg=p.querySelector('[data-qa-msg]'); msg.textContent='';
    var btn=p.querySelector('[data-qa-add]'); btn.disabled=true; btn.textContent=btn.getAttribute('data-l');
    if(qaData.locked){ btn.textContent=qaData.locked; }
    openLayer(p);
  }

  /* ----------------------------------------------------- fiche produit -- */
  function initPdp(root){
    each((root||d).querySelectorAll('[data-lz-pdp]'),function(pdp){
      if(pdp.__b){return;} pdp.__b=true;
      var data; try{ data=JSON.parse(pdp.querySelector('[data-pdp-json]').textContent); }catch(e){ return; }
      var hid=pdp.querySelector('[data-pdp-id]'), add=pdp.querySelector('[data-pdp-add]');
      var price=pdp.querySelector('[data-pdp-price]'), cmp=pdp.querySelector('[data-pdp-cmp]');
      function sel(){
        var opts=[]; each(pdp.querySelectorAll('[data-opt]'),function(g){
          var c=g.querySelector('input:checked'); opts[parseInt(g.getAttribute('data-opt'),10)]=c?c.value:null; });
        return opts;
      }
      function sync(){
        var o=sel(), v=null;
        data.variants.forEach(function(x){ var ok=true; x.options.forEach(function(val,i){ if(o[i]!=null&&o[i]!==val){ok=false;} }); if(ok&&!v){v=x;} });
        /* Disponibilité de chaque pointure pour la couleur choisie */
        var sizeIdx=data.sizeIndex;
        if(sizeIdx>-1){
          each(pdp.querySelectorAll('[data-opt="'+sizeIdx+'"] .lz-size'),function(l){
            var val=l.querySelector('input').value, av=false;
            data.variants.forEach(function(x){ var m=true; x.options.forEach(function(ov,i){ if(i===sizeIdx){ if(ov!==val){m=false;} } else if(o[i]!=null&&o[i]!==ov){m=false;} }); if(m&&x.available){av=true;} });
            l.classList.toggle('off',!av);
          });
        }
        var chosen=o.every(function(x){return x!=null;});
        if(v&&chosen){
          hid.value=v.id;
          if(price){ price.textContent=money(v.price); }
          if(cmp){ if(v.compare_at_price>v.price){ cmp.textContent=money(v.compare_at_price); cmp.hidden=false; } else { cmp.hidden=true; } }
          if(add&&!add.hasAttribute('data-locked')){ add.disabled=!v.available; add.querySelector('span').textContent=v.available?add.getAttribute('data-l'):add.getAttribute('data-sold'); }
          if(window.history&&window.history.replaceState&&!EDIT){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u.toString()); }
        } else if(add&&!add.hasAttribute('data-locked')){
          add.disabled=true; add.querySelector('span').textContent=add.getAttribute('data-pick');
        }
        each(pdp.querySelectorAll('.lz-color'),function(c){ c.classList.toggle('on',c.querySelector('input').checked); });
        each(pdp.querySelectorAll('[data-opt-val]'),function(s){ var g=s.getAttribute('data-opt-val'); var c=pdp.querySelector('[data-opt="'+g+'"] input:checked'); s.textContent=c?c.value:''; });
      }
      pdp.addEventListener('change',function(e){ if(e.target.closest('[data-opt]')){ sync(); } });
      sync();

      /* Ajout : produit + upsell coché envoyés ensemble */
      var form=pdp.querySelector('form[action*="/cart/add"]');
      if(form){ form.addEventListener('submit',function(e){
        e.preventDefault();
        if(!hid.value||add.disabled){return;}
        var items=[{id:parseInt(hid.value,10),quantity:1}];
        var up=pdp.querySelector('[data-up]:checked'); if(up){ items.push({id:parseInt(up.value,10),quantity:1}); }
        var lbl=add.querySelector('span'), old=lbl.textContent; add.disabled=true; lbl.textContent='…';
        addItems(items).then(function(){ window.location.href=(window.LZ&&window.LZ.cartUrl)||'/cart'; })
          .catch(function(err){ add.disabled=false; lbl.textContent=old; var m=pdp.querySelector('[data-pdp-msg]'); if(m){ m.textContent=(err&&err.description)||'Impossible d’ajouter cet article.'; } });
      }); }

      /* Points de la galerie mobile */
      var gal=pdp.querySelector('.lz-gal'), dots=pdp.querySelectorAll('.lz-gal__dots i');
      if(gal&&dots.length){ gal.addEventListener('scroll',function(){ var i=Math.round(gal.scrollLeft/gal.clientWidth); each(dots,function(x,j){ x.classList.toggle('on',i===j); }); },{passive:true}); }
    });
  }

  /* ------------------------------------------------------------ rails ---- */
  function railMove(btn){
    var sec=btn.closest('[data-lz-rail-wrap]'); if(!sec){return;}
    var rail=sec.querySelector('.lz-rail'); if(!rail){return;}
    var card=rail.firstElementChild; var step=card?card.getBoundingClientRect().width+24:300;
    rail.scrollBy({left:(btn.getAttribute('data-dir')==='next'?1:-1)*step,behavior:REDUCE?'auto':'smooth'});
  }

  /* ---------------------------------------------------------- newsletter --
     Deux formulaires sur la même page : on retient lequel a été envoyé
     pour n'afficher le message de succès que sous celui-là. */
  function initForms(){
    each(d.querySelectorAll('form[id^="lz-nl-"]'),function(f){
      if(f.__b){return;} f.__b=true;
      f.addEventListener('submit',function(){ try{ sessionStorage.setItem('lz-nl',f.id); }catch(e){} });
    });
    var sent=null; try{ sent=sessionStorage.getItem('lz-nl'); }catch(e){}
    each(d.querySelectorAll('[data-lz-nl-ok]'),function(m){
      if(sent&&m.getAttribute('data-lz-nl-ok')!==sent){ m.hidden=true; }
    });
  }

  /* ------------------------------------------------------- clics globaux -- */
  d.addEventListener('click',function(e){
    var t;
    if((t=e.target.closest('[data-lz-open]'))){ e.preventDefault(); openLayer(d.querySelector(t.getAttribute('data-lz-open'))); return; }
    if(e.target.closest('[data-lz-close]')){ e.preventDefault(); closeLayers(); return; }
    if((t=e.target.closest('.lz-faq__q'))){ toggleFaq(t); return; }
    if((t=e.target.closest('[data-lz-qa-open]'))){ e.preventDefault(); openQA(t.closest('.lz-card')); return; }
    if((t=e.target.closest('[data-rail]'))){ railMove(t); return; }
    if((t=e.target.closest('[data-qa-add]'))){
      var p=t.closest('[data-lz-qa]'), c=p.querySelector('input[name="lz-qa-v"]:checked'), msg=p.querySelector('[data-qa-msg]');
      if(!c||(qaData&&qaData.locked)){return;}
      t.disabled=true; t.textContent='…';
      addItems([{id:parseInt(c.value,10),quantity:1}]).then(function(){
        t.textContent=t.getAttribute('data-ok'); msg.innerHTML='<a class="lz-link" href="'+((window.LZ&&window.LZ.cartUrl)||'/cart')+'">Voir le panier</a>';
      }).catch(function(err){ t.disabled=false; t.textContent=t.getAttribute('data-l'); msg.textContent=(err&&err.description)||'Impossible d’ajouter cet article.'; });
    }
  });
  d.addEventListener('change',function(e){
    if(e.target.name==='lz-qa-v'){ var p=e.target.closest('[data-lz-qa]'); var b=p.querySelector('[data-qa-add]'); if(!(qaData&&qaData.locked)){ b.disabled=false; b.textContent=b.getAttribute('data-l'); } }
    if(e.target.matches('[data-lz-sort]')){ var u=new URL(location.href); u.searchParams.set('sort_by',e.target.value); location.href=u.toString(); }
  });
  d.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeLayers(); } });
  window.addEventListener('resize',function(){ each(d.querySelectorAll('[data-lz-faq].open .lz-faq__a'),function(a){ a.style.maxHeight=a.scrollHeight+'px'; }); });

  /* ------------------------------------------------------- jeu-concours --
     Trois étapes (forme → couleur → coordonnées). Les choix partent dans les
     étiquettes de la cliente Shopify : jeu-forme-…, jeu-couleur-…, jeu-insta-… */
  function initJeu(root){
    var sec=(root.matches&&root.matches('[data-lz-jeu]'))?root:root.querySelector('[data-lz-jeu]');
    if(!sec||sec.__b){ return; } sec.__b=true;
    var saved=null, done=null;
    try{ saved=JSON.parse(sessionStorage.getItem('lz-jeu')||'null'); done=JSON.parse(localStorage.getItem('lz-jeu-done')||'null'); }catch(e){}

    /* Message final (inscription réussie ou déjà inscrite) : récap + partage */
    function fin(box,info){
      var recap=box.querySelector('[data-lz-jeu-recap]');
      if(recap&&info&&info.label){ recap.textContent='Ta paire préférée : '+info.label+'. '+recap.textContent; }
      var sh=box.querySelector('[data-lz-jeu-share]');
      if(sh){ sh.addEventListener('click',function(){
        var url=location.origin+location.pathname, data={title:'LILIZOU · Jeu de Noël',text:'8 paires de bottes LILIZOU à gagner, tente ta chance :',url:url};
        if(navigator.share){ navigator.share(data).catch(function(){}); return; }
        if(navigator.clipboard){ navigator.clipboard.writeText(url).then(function(){ sh.textContent='Lien copié'; }); }
      }); }
    }

    var ok=sec.querySelector('[data-lz-jeu-ok]');
    if(ok){
      /* Une seule participation : ce navigateur est marqué comme inscrit */
      var info=saved||done||{}; info.t=Date.now();
      try{ localStorage.setItem('lz-jeu-done',JSON.stringify(info)); }catch(e){}
      fin(ok,info); return;
    }

    var form=sec.querySelector('[data-lz-jeu-form]'); if(!form){ return; }
    var deja=sec.querySelector('[data-lz-jeu-deja]');
    if(done&&deja&&!sec.querySelector('.lz-jeu__err')){
      form.hidden=true; deja.hidden=false; fin(deja,done); return;
    }
    var steps=sec.querySelectorAll('[data-lz-jeu-step]'), dots=sec.querySelectorAll('[data-lz-jeu-dot]');
    var next2=sec.querySelector('[data-lz-jeu-next2]'), choice=sec.querySelector('[data-lz-jeu-choice]');
    var cur=1, forme=null, couleur=null, byPointer=false;

    function go(n){
      var dir=n>=cur?1:-1; cur=n;
      each(steps,function(s){ var on=+s.getAttribute('data-lz-jeu-step')===n; s.classList.toggle('on',on); if(on){ s.style.setProperty('--dir',dir); } });
      each(dots,function(li){ var k=+li.getAttribute('data-lz-jeu-dot'); li.classList.toggle('on',k===n); li.classList.toggle('done',k<n); });
      var top=sec.querySelector('.lz-jeu__steps').getBoundingClientRect().top;
      if(top<0||top>window.innerHeight*.6){ sec.querySelector('.lz-jeu__steps').scrollIntoView({behavior:REDUCE?'auto':'smooth',block:'start'}); }
      if(n===3){ var em=form.querySelector('input[type=email]'); if(em&&!byPointer){ em.focus({preventScroll:true}); } }
    }
    function label(name){ var i=form.querySelector('input[name="'+name+'"]:checked'); return i?i.getAttribute('data-label'):''; }
    function view(){
      var key=(forme||'drapee')+'-'+(couleur||'noir');
      each(sec.querySelectorAll('.lz-jeu__view img'),function(img){
        if(forme&&img.getAttribute('data-v').indexOf(forme+'-')===0){ img.loading='eager'; }
        img.classList.toggle('on',img.getAttribute('data-v')===key);
      });
      if(choice){ choice.textContent=(label('lz-forme')+' '+label('lz-couleur')).trim(); }
    }
    function mark(input){
      each(form.querySelectorAll('input[name="'+input.name+'"]'),function(r){ r.closest('label').classList.toggle('sel',r.checked); });
    }

    form.addEventListener('pointerdown',function(){ byPointer=true; });
    form.addEventListener('keydown',function(){ byPointer=false; });
    form.addEventListener('change',function(e){
      var t=e.target;
      if(t.name==='lz-forme'){ forme=t.value; mark(t); view(); if(byPointer){ setTimeout(function(){ go(2); },380); } }
      if(t.name==='lz-couleur'){ couleur=t.value; mark(t); view(); next2.disabled=false; }
    });
    sec.addEventListener('click',function(e){
      var b=e.target.closest('[data-lz-jeu-go]'); if(!b||b.disabled){ return; }
      var n=+b.getAttribute('data-lz-jeu-go'); if(n===2&&!forme){ return; } go(n);
    });
    /* Clavier : Entrée sur une forme passe à l'étape suivante */
    form.addEventListener('keydown',function(e){
      if(e.key==='Enter'&&e.target.name==='lz-forme'){ e.preventDefault(); if(forme){ go(2); } }
      if(e.key==='Enter'&&e.target.name==='lz-couleur'){ e.preventDefault(); if(couleur){ go(3); } }
    });

    form.addEventListener('submit',function(e){
      if(!forme||!couleur){ e.preventDefault(); go(!forme?1:2); return; }
      var tags=['jeu-noel-2026','newsletter','jeu-forme-'+forme,'jeu-couleur-'+couleur];
      /* Abonnement requis : réseau + pseudo, vérifiés à la main au tirage */
      var ins=sec.querySelector('[data-lz-jeu-insta]'), net=form.querySelector('input[name="lz-reseau"]:checked');
      var h=ins?ins.value.trim().replace(/^@+/,'').toLowerCase().replace(/[^a-z0-9._]/g,'').slice(0,30):'';
      if(ins&&!h){ e.preventDefault(); ins.setCustomValidity('Indique ton pseudo (lettres, chiffres, point ou tiret bas).'); ins.reportValidity();
        ins.addEventListener('input',function(){ ins.setCustomValidity(''); },{once:true}); return; }
      if(h){ tags.push('jeu-'+(net?net.value:'insta')+'-'+h); }
      sec.querySelector('[data-lz-jeu-tags]').value=tags.join(',');
      try{ sessionStorage.setItem('lz-jeu',JSON.stringify({forme:forme,couleur:couleur,insta:h,label:(label('lz-forme')+' '+label('lz-couleur')).trim()})); }catch(err){}
      var btn=form.querySelector('.lz-jeu__go'); if(btn){ btn.textContent='Envoi…'; }
    });

    /* Retour d'erreur (e-mail invalide…) : on rétablit les choix et on revient à l'étape 3 */
    view();
    if(sec.querySelector('.lz-jeu__err')&&saved){
      var f=form.querySelector('input[name="lz-forme"][value="'+saved.forme+'"]'), c=form.querySelector('input[name="lz-couleur"][value="'+saved.couleur+'"]');
      if(f&&c){ f.checked=c.checked=true; forme=saved.forme; couleur=saved.couleur; mark(f); mark(c); view(); next2.disabled=false;
        var ins2=sec.querySelector('[data-lz-jeu-insta]'); if(ins2&&saved.insta){ ins2.value=saved.insta; } go(3); }
    }
  }

  /* Carte flottante : à chaque visite (une fois par session), jamais après la
     fin du jeu, et plus du tout une fois que ce navigateur a participé */
  function initJeuPop(){
    var el=d.querySelector('[data-lz-jpop]'); if(!el||el.__b||EDIT){ return; } el.__b=true;
    if(Date.now()/1000>+el.getAttribute('data-fin')){ return; }
    var skip=false; try{ skip=!!localStorage.getItem('lz-jeu-done')||!!sessionStorage.getItem('lz-jpop'); }catch(e){}
    if(skip){ return; }
    var shown=false, timer;
    function show(){ if(shown){ return; } shown=true; clearTimeout(timer); window.removeEventListener('scroll',onScroll);
      el.hidden=false; void el.offsetWidth; el.classList.add('on'); }
    function hide(){ try{ sessionStorage.setItem('lz-jpop','1'); }catch(e){}
      el.classList.remove('on'); setTimeout(function(){ el.hidden=true; },800); }
    function onScroll(){ var h=d.documentElement; if(h.scrollTop>(h.scrollHeight-h.clientHeight)*.33){ show(); } }
    /* Arrive ~1 s après le chargement, ou juste après l'intro si elle est jouée */
    var intro=d.querySelector('[data-lz-intro]');
    (function wait(){
      if(intro&&!intro.classList.contains('gone')){ timer=setTimeout(wait,200); return; }
      timer=setTimeout(show,intro?600:1000);
    })();
    window.addEventListener('scroll',onScroll,{passive:true});
    el.querySelector('[data-lz-jpop-x]').addEventListener('click',hide);
    el.querySelector('a').addEventListener('click',function(){ try{ sessionStorage.setItem('lz-jpop','1'); }catch(e){} });
    d.addEventListener('keydown',function(e){ if(e.key==='Escape'&&el.classList.contains('on')){ hide(); } });
  }

  /* ------------------------------------------------------ vidéos 9:16 --
     Muettes, en boucle, lues seulement à l'écran (chargées un peu avant).
     Mouvement réduit demandé : pas de lecture automatique, image fixe. */
  function initVids(root){
    var vids=root.querySelectorAll('[data-lz-vids] video'); if(!vids.length){ return; }
    if(REDUCE||!('IntersectionObserver' in window)){ return; }
    var near=new IntersectionObserver(function(es){ es.forEach(function(e){
      if(e.isIntersecting){ e.target.preload='auto'; near.unobserve(e.target); } }); },{rootMargin:'300px 200px'});
    var seen=new IntersectionObserver(function(es){ es.forEach(function(e){
      var v=e.target; if(e.isIntersecting){ v.muted=true; var p=v.play(); if(p){ p.catch(function(){}); } } else { v.pause(); } }); },{threshold:.35});
    each(vids,function(v){ if(v.__b){ return; } v.__b=true; near.observe(v); seen.observe(v); });
  }

  function all(root){ initIntro(); initNav(); initAnn(root); initReveals(root); initPdp(root); initForms(); initHero(); initJeu(root); initJeuPop(); initVids(root); }
  ready(function(){ all(d); });
  d.addEventListener('shopify:section:load',function(e){ all(e.target); });
})();
